import type { DriveStep } from "driver.js";

export const SHELL_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="sidebar"]',
    popover: {
      title: "Navigation",
      description:
        "Die Seitenleiste führt zu allen Rezeptionsbereichen: Dashboard, Anreisen, Abreisen, Platzplan, Gäste und Buchungen. Favoriten und zuletzt besuchte Seiten erscheinen oben.",
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="bottom-nav"]',
    popover: {
      title: "Schnellzugriff (Mobil)",
      description:
        "Auf dem Smartphone erreichen Sie die wichtigsten Rezeptionsfunktionen über die untere Leiste: Start, Anreisen, Abreisen, Buchungen und Kasse.",
      side: "top",
      align: "center",
    },
  },
  {
    element: '[data-tour="header-search"]',
    popover: {
      title: "Schnellsuche",
      description:
        "Mit Strg+K (oder ⌘+K) öffnen Sie die Schnellsuche. Dort springen Sie zu Bereichen, finden Gäste und Buchungen oder starten Aktionen direkt.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: '[data-tour="tour-help"]',
    popover: {
      title: "Hilfe & Touren",
      description:
        "Über dieses Symbol starten Sie jederzeit die Erklärung für die aktuelle Seite. Im Benutzermenü können Sie alle Touren zurücksetzen.",
      side: "bottom",
      align: "end",
    },
  },
];
